<template>
  <tbody>
    <tr
      v-for="(item, i) in items"
      :key="i"
      :class="{'text-xs-center': true}">
      <td width="120">
        <v-avatar size="45" class="transparent">
          <v-icon large class="k-orange-linear-text" v-if="item.type === 'phone'">fas fa-phone fa-rotate-90</v-icon>
          <v-icon large class="k-orange-linear-text" v-else="item.type === 'email'">fas fa-envelope</v-icon>
        </v-avatar>
      </td>
      <td class="text-xs-left">
        {{item.name ? item.name : `${item.first_name} ${item.last_name ? item.last_name : ''}`}}
        <small v-if="item.type === 'test'">
          Prueba
        </small>
        <small v-else>
          Cuenta: {{ item.account }}
        </small>
      </td>
      <td class="text-xs-left">
        {{ item.sent_info }}
      </td>
      <td class="text-xs-left">
        {{ formatDate(item.checked_at, 'YYYY-MM-DD','DD/MM/YYYY') }}
        <small>{{ formatDate(item.checked_at, 'YYYY-MM-DD HH:mm:ss','h:mm A') }}</small>
      </td>
      <td class="text-xs-left" width="130px">
          <v-chip
            slot="activator"
            color="transparent"
            :class="{'subheading':true, 'blue--text':item.status === 'Pendiente', 'green--text':item.status === 'Valido', 'red--text':item.status === 'Invalido', 'orange--text':item.status === 'Rechazado' }"
          >
            {{ item.status }}
            <v-icon small class="pl-2" v-if="item.status === 'Pendiente'">fas fa-clock</v-icon>
            <v-icon small class="pl-2" v-else-if="item.status === 'Valido'">fas fa-check</v-icon>
            <v-icon small class="pl-2" v-else-if="item.status === 'Invalido'">fas fa-times</v-icon>
          </v-chip>
      </td>
    </tr>
  </tbody>
</template>

<script>
import moment from 'moment';

export default {
  props: ['items'],
  methods: {
    formatDate(date, firstFormat, dateFormat) {
      return moment(date, firstFormat).format(dateFormat);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/invalid_data/InvalidDataList.vue